import { useRouter } from "next/compat/router";
import { useFormContext } from "react-hook-form";
import { FaCheckCircle } from "react-icons/fa";

import { buildOnboardingPayload } from "./buildOnboardingPayload";
import OnboardingWizardStepFooter from "./OnboardingWizardStepFooter";
import { setOnboardingPersonProperties } from "./onboardingPersonProperties";
import type { WizardFormValues } from "./onboardingWizardForm";
import useOnboardingTracking from "./useOnboardingTracking";
import { useOnboarding } from "~/hooks";

const OnboardingWizardStepComplete = () => {
	const router = useRouter();
	const { handleUpdate, learningPath } = useOnboarding();
	const { getValues } = useFormContext<WizardFormValues>();
	const { track } = useOnboardingTracking();

	const handleGoToPlan = async () => {
		await handleUpdate({ isOnboardingCompleted: true });
		const payload = buildOnboardingPayload(getValues(), learningPath);
		track("onboarding:completed", { source: "live" });
		setOnboardingPersonProperties(payload, learningPath);
		router?.push("/learning-plan");
	};

	return (
		<div className="flex flex-col items-center justify-center gap-10 text-center">
			<div className="flex h-28 w-28 items-center justify-center rounded-full bg-green-100 dark:bg-green-300/10">
				<FaCheckCircle
					className="text-green-500 dark:text-green-400"
					size={56}
				/>
			</div>

			<div className="flex flex-col gap-6">
				<h2 className="font-semibold text-2xl text-black leading-tight dark:text-white">
					You're all set!
				</h2>

				<p className="text-slate-500 text-sm leading-relaxed dark:text-slate-200">
					Your personalised learning plan is ready. Head to your learning plan
					to see your courses and track your progress.
				</p>
			</div>

			<div className="w-full">
				<OnboardingWizardStepFooter
					primary={{ label: "View My Learning Plan", onClick: handleGoToPlan }}
				/>
			</div>
		</div>
	);
};

export default OnboardingWizardStepComplete;
